import { Navigate, useLocation } from "react-router-dom";
import { decryptFromStoreLoc } from "./localStorage";

function PrivateRoute({ children, ...rest }) {
  let location = useLocation();

  let isLoggedIn = !!decryptFromStoreLoc("token");


  return isLoggedIn ? (
    children
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
}

export default PrivateRoute;
